var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2336_8856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.58398 11.9966C8.58398 12.9631 7.80048 13.7466 6.83398 13.7466C5.86748 13.7466 5.08398 12.9631 5.08398 11.9966C5.08398 11.0301 5.86748 10.2466 6.83398 10.2466C7.80048 10.2466 8.58398 11.0301 8.58398 11.9966ZM14.584 11.9966C14.584 12.9631 13.8005 13.7466 12.834 13.7466C11.8675 13.7466 11.084 12.9631 11.084 11.9966C11.084 11.0301 11.8675 10.2466 12.834 10.2466C13.8005 10.2466 14.584 11.0301 14.584 11.9966ZM18.834 13.7466C19.8005 13.7466 20.584 12.9631 20.584 11.9966C20.584 11.0301 19.8005 10.2466 18.834 10.2466C17.8675 10.2466 17.084 11.0301 17.084 11.9966C17.084 12.9631 17.8675 13.7466 18.834 13.7466Z",
    fill: "#A7A7A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2336_8856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.833984)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.3bddb69e0ecb6857f09c48a849e8e3f2.svg";
export { ForwardRef as ReactComponent };